<template>
    <footer class="login-footer">
      <span>Mau Mengaktifkan Akun?</span>
      <RouterLink to="/activate-account">
         Klik Disini
      </RouterLink>
    </footer>
  </template>
  
  <script>
  import { RouterLink } from 'vue-router'
  
  export default {
    name: 'LoginFooter',
  
    components: {
      RouterLink
    }
  }
  </script>